import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { PackedCellVolumeAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-packed-cell-volume-slot',
    templateUrl: './packed-cell-volume-slot.component.html',
    styleUrl: './packed-cell-volume-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackedCellVolumeSlotComponent implements SheetSlotComponentBase {

	action!: PackedCellVolumeAction;
	value!: string | null;

	@Input('action') set updateAction(action: PackedCellVolumeAction | null) {
		this.action = action as PackedCellVolumeAction;
		this.value = this.action.pcv?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}